import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import Lock from "../icon/Lock";
import RemoveIcon from "../icon/RemoveIcon";
import "../style/cart.scss";
import { useSelector, useDispatch } from "react-redux";
import { removeItem } from "../store/cartSlice";
import { routeToPage } from "../util/RouteToPage";
import PagePath from "../util/RoutePagePath";
import Number from "./common/Number";
import { currency } from "./common/Common";

const Cart = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);
  const total = cartItems.reduce(
    (sum, item) => sum + item.total * item.quantity,
    0,
  );

  const removeItemFormCart = (id) => {
    dispatch(removeItem(id));
  };

  return (
    <React.Fragment>
      <HeaderBar />

      <div className="min-h-screen bg-white">
        <div className="mx-auto max-w-[1200px] px-6 py-20">
          {/* title */}
          <div className="mb-16 border-b pb-10">
            <h1 className="text-5xl font-light tracking-wide">Cart</h1>

            <p className="mt-3 text-sm text-neutral-500">
              {cartItems.length} item(s)
            </p>
          </div>

          {cartItems.length > 0 ? (
            <div className="grid gap-16 lg:grid-cols-[1fr_340px]">
              {/* left products */}
              <div>
                {cartItems.map((item, index) => (
                  <div key={index} className="flex gap-6 border-b py-10">
                    {/* image */}
                    <img
                      src={item?.image?.[0]}
                      alt=""
                      className="h-28 w-28 object-cover"
                    />

                    {/* info */}
                    <div className="flex flex-1 flex-col justify-between">
                      <div>
                        <h3 className="text-base font-normal">{item.title}</h3>

                        <button
                          onClick={() => removeItemFormCart(item.id)}
                          className="mt-2 text-xs text-neutral-400 hover:text-black"
                        >
                          Remove
                        </button>
                      </div>

                      <div className="mt-6 flex items-center justify-between">
                        <div className="text-sm text-neutral-500">
                          Qty:{" "}
                          <span className="text-black">
                            <Number id={item.id} num={item.quantity} />
                          </span>
                        </div>

                        <div className="text-sm">
                          {currency}
                          {item?.total?.toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* right summary */}
              <div className="border-l pl-10">
                <div className="sticky top-24">
                  <h2 className="mb-10 text-lg font-normal tracking-wide">
                    Summary
                  </h2>

                  <div className="space-y-6 text-sm">
                    <div className="flex justify-between">
                      <span className="text-neutral-500">Subtotal</span>
                      <span>
                        {currency}
                        {total.toFixed(2)}
                      </span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-neutral-500">Shipping</span>
                      <span>Free</span>
                    </div>

                    <div className="flex justify-between">
                      <span className="text-neutral-500">Tax</span>
                      <span>Included</span>
                    </div>

                    <div className="flex justify-between border-t pt-6 text-base">
                      <span>Total</span>
                      <span>
                        {currency}
                        {total.toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <button
                    onClick={() =>
                      routeToPage(navigate, PagePath.CHECKOUT_PAGE)
                    }
                    className="mt-10 w-full border border-black py-4 text-xs uppercase tracking-[3px] transition hover:bg-black hover:text-white"
                  >
                    Checkout
                  </button>

                  <button
                    onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                    className="mt-4 w-full text-xs text-neutral-500 hover:text-black"
                  >
                    Continue Shopping
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex min-h-[500px] flex-col items-center justify-center text-center">
              <h2 className="text-3xl font-light">Cart is empty</h2>

              <p className="mt-3 text-sm text-neutral-500">
                No items added yet
              </p>

              <button
                onClick={() => routeToPage(navigate, PagePath.HOME_PAGE)}
                className="mt-10 border border-black px-8 py-3 text-xs uppercase tracking-[3px] hover:bg-black hover:text-white"
              >
                Start Shopping
              </button>
            </div>
          )}
        </div>
      </div>

      <FooterBar />
    </React.Fragment>
  );
};

export default Cart;
